import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import './App.css';
import Navbar from './components/Navbar';
import axios from "axios";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import { CookieSetting } from "cookiesetting-component";
const Article = lazy(() => import("./components/Article"));
const Body = lazy(() => import("./components/Body"));
const Contact = lazy(() => import("./components/Contact"));
const Footer = lazy(() => import("./components/Footer"));

function App() {
  const [links, setLinks] = useState(null); // Set initial state as null
  const appVersion = appversion.version;

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);
  return (
    <>
<CacheBuster
      currentVersion={appVersion}
      isEnabled ={true}
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={'.'}
    >
{links ? (
        <>
    <Suspense fallback={<div />}>
      <Navbar />
      </Suspense>
      <Suspense fallback={<div />}>
        <Article />
      </Suspense>
      <Suspense fallback={<div />}>
        <Contact />
      </Suspense>
      <Suspense fallback={<div />}> 
        <Body links={links.current}/>
      </Suspense>
      <Suspense fallback={<div />}> 
        <Footer />
      </Suspense>

      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
</>
) : (

  <div>Loading...</div>

)}
</CacheBuster>
    </>
    
  );
}

export default App;
